import React from 'react'
import './Program.css'
import { programsData } from '../../data/programsData'
import RightArrow from '../../assets/rightArrow.png'
const program = () => {
  return (
    <div className="programs" id="programs">
        {/* header*/}

        <div className="programs-header">
            <span className='stroke-text'>Explore out</span>
            <span>Programs</span>
            <span className='stroke-text'>to shape ypu</span>
        </div>

        <div className="program-categories">
            {programsData.map((program)=>(
                <div className="categgory">
                    {program.image}
                    <span>{program.heading}</span>
                    <span>{program.details}</span>
                    <div className="join-now"><span>Join Now</span><img src={RightArrow} alt="" /></div>
                </div>
            ))}
        </div>

    </div>
  )
}

export default program
